/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  index_patient_info: {},
  index_patient_current_cases: [],
  index_patient_contacts: [],

  patient_info: {},
  patient_current_cases: [],
  patient_contacts: [],
  patient_researches: {"tb": {}, "tbi": {}},
  patient_treatments: [],
  followups: [],

  institutions: [],
  contacts: [],
  contacts_meta: null,
  risk_groups: [],
  risk_groups_meta: null,
  index_patients: [],
  index_meta: null,
}
